import * as React from 'react';
import withStyles, { WithStyles, StyleRules, ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Switch, Route } from 'react-router-dom';
import { Theme } from '@material-ui/core/styles';
import AppView from '~common/components/app-view/index';
import GroupFeatureRelationList from '~users/components/group-feature-relation-list';
import FormBasedEditor from '~common/form/form-based-editor';
import * as request from 'superagent';
import {setValueAtPath} from '~common/form/helper';
import URLManager from '~common/lib/url-manager';
import LoadingView from '~common/components/loading-view';
import ErrorView from '~common/components/error-view';
import { APIError } from '~common/lib/types';


const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
	match: any;
}

type State = {
	status: "loading" | "ready"
	data: any;
	form: any;
	definitions: Array<any>;
	error?: any;
};

class PortalGroupEditor extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			status: "loading",
			data: {},
			form: {},
			definitions: []
		};
	}

	componentDidMount() {
		console.log("group mount")
		
		var {id} = this.props.match.params
		var promises: Array<any> = [
			request.get(
			  '/api/form-definitions/select?selector='+URLManager.getQueryStringValue({"form": "portalGroupEditor", "module": "users", "userType": "Internal"})),
			  
		];
		if(id!=="new"){
			promises.push(request.get("/api/portal-groups" + '/' + id))
		  }
		Promise.all(promises).then((values: Array<request.Response>)=>{
			console.log("values", values)
			let newData = {
				groupInfo: {
					groupType: "Feature"
				},
				features: {},
				users: {}
		}
			if (values.length > 1) {
				newData = values[1].body
			}
			this.setState({
				status: "ready",
				form: values[0].body,
				definitions: values[0].body.definitions,
				data: newData
			})
		}).catch((err)=>{
			const apiErr = new APIError()
            apiErr.type = "http"
			apiErr.message = (err.response || { text: err.toString() }).text
			this.setState({
				error: apiErr
			})
		})
	}

	componentWillReceiveProps() {
		
	}
	// handleChangeAtPath is used to ferry changes from owned components upstream
	handleChangeAtPath = (path: string, value: any) => {
		let {data} = this.state;
		let svpResp = setValueAtPath(path, data, value);
		data = svpResp.data;
	
		if (svpResp.err) {
		  console.error(svpResp.err);
		}
	
		// Save the data and then show the user progress against errors
		this.setState({data});
		console.log("group state", this.state)
	};

	handleErrorClose = () => {
		this.setState({
			error: undefined
		})
	}

	render() {
		const { classes }: { classes: ClassNameMap } = this.props;
		var {status, data, form, definitions, error} = this.state

		console.log("group edit view...", data)
		// set restrictToUserType so that the features available for assignment can be filtered by the appropriate type.
		if (data.features && data.groupInfo) {
			data.features.restrictToUserType = data.groupInfo.restrictToUserType
		}

		if (form && definitions) {
			form.definitions = []
			var groupInfoDef = definitions.find((d: any)=>{return d.key == "groupInfo"})
			if (groupInfoDef) {
				form.definitions.push(groupInfoDef)
			}

			// add the features definition if the group is specified as a Feature Group.
			if (data.groupInfo && data.groupInfo.groupType == "Feature") {
				var featuresDef = definitions.find((d: any)=>{return d.key == "features"})
				if (featuresDef) {
					form.definitions.push(featuresDef)
				}
			}

			var usersDef = definitions.find((d: any)=>{return d.key == "users"})
			if (usersDef && data.groupInfo && data.groupInfo.restrictToUserType) {
				usersDef.predefined.forEach((pdf: any)=>{
					if (pdf.key == "assignedUsers") {
						pdf.appendToQuery = [
							{
								key: "userType",
								value: data.groupInfo.restrictToUserType
							}
						]
					}
				})
				form.definitions.push(usersDef)
			}

			// add the vendors definition if the group is specified as a Vendor Group.
			if (data.groupInfo && data.groupInfo.restrictToUserType == "Vendor") {
				var relationDef = definitions.find((d: any)=>{return d.key == "relations"})
				if (relationDef) {
					form.definitions.push(relationDef)
				}				
			}
		}

		var errorView: any = null;
        if (error) {
          errorView = <ErrorView onClose={this.handleErrorClose} classes={{}} error={error} />;
        }

		var criteria = URLManager.getQueryString(window.location.href)

		switch(status) {
			case "loading":
				return <LoadingView classes={{}} />;
			case "ready":
				return (
					<div className={classes.container}>
						{error && errorView}
						<AppView history={this.props.history}>
						<FormBasedEditor 
							history={this.props.history} 
							match={this.props.match}
							dataUrl="/api/portal-groups"
							data={data}
							onChangeAtPath={this.handleChangeAtPath}
							form={form}
							successMessage="Portal Group Successfully Saved"
							customRenderers={{
								"GroupFeatureRelationList": GroupFeatureRelationList
							}}
							allowDelete={(data || {groupInfo:{}}).groupInfo.id}
							confirmDeleteMessage={"Are you sure you want to delete this group?"}
							redirectUrl={`/groups/admin?q=${URLManager.getQueryStringValue(criteria)}`}
						>
					  </FormBasedEditor>
					</AppView>
					</div>
				);
		}

		
	}
}

export default withStyles(styles)(PortalGroupEditor);
